<template>
  <span :id="name" v-katex:auto="options">
    <slot>...</slot>
  </span>
</template>

<script>
// import VueKatex from 'vue-katex'
import 'katex/dist/katex.min.css'

export default {
  props: {
    name: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      options: {
        strict: false,
        delimiters: [
          { left: '$$', right: '$$', display: true },
          { left: '$', right: '$', display: false },
          { left: '\\(', right: '\\)', display: false }
        ]
      }
    }
  }
}
</script>
